import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';
import * as $ from 'jquery';
import { useNavigate } from 'react-router-dom';

const HeaderLogo = ({logo}) => {
  const [h, setH] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const h = $('#header-container').outerHeight();
    setH(h);
  }, [setH]);

  const goToHome = () => {
    navigate('/');
  };

  return (
    <div id='header-relative' style={{height: `${h}px`}}>
      <Container id='header-container' style={{'filter' : 'drop-shadow(0px 1px 1px gray)'}} fluid className={localStorage.getItem('branding') === "ARROWSTREAM" ? 'arrowstreamGradient p-2' : 'beplGradient p-2'}>
        <Row>
          <Col className='text-center'>
            <img src={logo} alt='Company Logo' className='company-logo clickable' onClick={goToHome}/>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

HeaderLogo.propTypes = {
  logo: PropTypes.string.isRequired
};

export default HeaderLogo;